import React, { useEffect, useState } from 'react'
import { CCol, CRow, CSpinner } from '@coreui/react'
import { api } from '../api/client'
import WwGrid, { WwColumn } from '../components/ww/WwGrid'

// Módulos por empresa — ruta /superadmin/modulos (vista de solo lectura).
// Datos expuestos por GET /api/superadmin/empresas (no se inventa endpoint).
const SuperAdminModulosPage: React.FC = () => {
  const [empresas, setEmpresas] = useState<any[]>([])
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    api.get<any[]>('/superadmin/empresas')
      .then(setEmpresas)
      .catch(() => undefined)
      .finally(() => setCargando(false))
  }, [])

  // Módulos por empresa: EmpresaModuloFacturacion (MenuController.cs:43).
  // Cambio Sencilla y Domicilio fueron retirados (idea no aterrizada).
  const columnas: WwColumn[] = [
    { key: 'empresaCodigo', title: 'Empresa' },
    { key: 'empresaNombre', title: 'Nombre' },
    { key: 'empresaModuloFacturacion', title: 'Facturacion', type: 'bool' },
  ]

  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4 className="mb-0 fw-bold">Módulos</h4>
          <small className="text-body-secondary">
            Módulos activos por empresa — vista de solo lectura.
          </small>
        </CCol>
      </CRow>
      {cargando ? (
        <div className="text-center py-4"><CSpinner color="primary" /></div>
      ) : (
        <WwGrid title="Módulos" columns={columnas} rows={empresas} onTotalChange={() => undefined} />
      )}
    </>
  )
}

export default SuperAdminModulosPage
